import React from 'react'

import tileimage61 from '../assets/images/whoweare/John_Szczepanski.jpg'
import tileimage1451 from '../assets/images/whoweare/PHIL_ENDE_BW_web.jpg'
import tileimage1452 from '../assets/images/whoweare/Kristin_Clifford_Digital_BW.jpg'
import tileimage14534 from '../assets/images/whoweare/rajendra.jpg'
import tileimage145345 from '../assets/images/whoweare/tiffany.jpg'
import tileimage1453456 from '../assets/images/whoweare/KG_Headshot_turtleneck_BW.jpg'
import Alexandra from '../assets/images/whoweare/Alex_Derner_BW_WEB.jpg'
import lisaPillette from '../assets/images/whoweare/LISA_P_WEB_BW.jpg'
import kimKetch from '../assets/images/whoweare/KIM_KETCH_WEB_BW.jpg'
import kenli from '../assets/images/whoweare/Kenneth Li_015_WEB_BW.jpg'
import ericwarner from '../assets/images/whoweare/TCP_EXEC_ERIC_WAGNER_BW_WEB.jpg'

const MBSeniorLeadership = () => (
  <div
    class="secondgroup text-left accordion"
    id="mbseniorleadershipcolapsegroup"
  >

 
    <div>
      <a
        class="row btn p-0 mb-1 d-flex collapsed"
        data-toggle="collapse"
        href="#collapseExample1"
        role="button"
        aria-expanded="false"
        aria-controls="collapseExample1"
      >
        <div class="col-12">
          <hr class="border-top " />
        </div>
        <div class="col-4 fill">
          <img src={tileimage61} className="img-fluid mb-2" alt="" />
        </div>

        <div class="col-8 text-left">
          <h5>JOHN SZCZEPANSKI</h5>
          <p>Chief Financial Officer</p>
        </div>
      </a>
      <div
        class="row mt-4 collapse close-button"
        id="collapseExample1"
        data-toggle="collapse"
        data-target="#collapseExample1"
        aria-expanded="false"
        aria-controls=""
        data-parent="#mbseniorleadershipcolapsegroup"
      >
        <div class="col-12">
          <p className="text-left">
          John joined The Children’s Place in 2025 as Chief Financial Officer, overseeing Accounting, Financial Planning & Analysis, Tax, Treasury, Internal Audit, Real Estate, and Investor Relations. In addition, he leads the Supply Chain and Legal organizations, helping drive financial discipline, operational excellence, strong governance, and disciplined execution across key business functions. John brings extensive financial leadership experience across the retail and manufacturing sectors. Prior to joining The Children’s Place, he served as Chief Financial Officer at Vince Holding Corp. Before that, he held significant roles at Ralph Lauren Corporation, where he held leadership roles of increasing responsibility, ultimately serving as Chief Financial Officer for the Global Supply Chain, Brands, and Lifestyle Group. John holds a Master of Science in Finance from Boston College’s Carroll School of Management and a Bachelor of Science in Accounting from Fordham University.
          </p>
        </div>
      </div>
    </div>
    
    <div>
      <a
        class="row btn p-0 mb-1 d-flex collapsed"
        data-toggle="collapse"
        href="#collapseExample2a"
        role="button"
        aria-expanded="false"
        aria-controls="collapseExample2a"
      >
        <div class="col-12">
          <hr class="border-top " />
        </div>
        <div class="col-4 fill">
          <img src={lisaPillette} className="img-fluid mb-2" alt="" />
        </div>

        <div class="col-8 text-left">
          <h5>LISA PILLETTE</h5>
          <p>Chief Customer Officer</p>
        </div>
      </a>
      <div
        class="row mt-4 collapse close-button"
        id="collapseExample2a"
        data-toggle="collapse"
        data-target="#collapseExample2a"
        aria-expanded="false"
        aria-controls=""
        data-parent="#mbseniorleadershipcolapsegroup"
      >
        <div class="col-12">
          <p className="text-left">
          Lisa joined The Children’s Place in 2026 as Chief Customer Officer, where she leads the Company’s front-end transformation, overseeing brand strategy, creative direction, and marketing initiatives. Lisa brings extensive global marketing and brand leadership experience, having served as Global Chief Marketing Officer at Fossil Group and Chief Marketing Officer at Casper Sleep. She previously held senior marketing roles at Lacoste and Ralph Lauren Corporation, leading brand strategy, marketing, CRM, and analytics initiatives. She is known for driving brand transformation through consumer-focused marketing, digital innovation, and culture-led design. Lisa graduated from the University of Colorado Boulder and serves on several industry boards and advisory councils, including MyCode, the National Association for Business Economics Chicago Chapter, the CMO Council, and TRIPTK.
          </p>
        </div>
      </div>
    </div>
    <div>
      <a
        class="row btn p-0 mb-1 d-flex collapsed"
        data-toggle="collapse"
        href="#collapseExample4"
        role="button"
        aria-expanded="false"
        aria-controls="collapseExample4"
      >
        <div class="col-12">
          <hr class="border-top " />
        </div>
        <div class="col-4 fill">
          <img src={tileimage1453456} className="img-fluid mb-2" alt="" />
        </div>

        <div class="col-8 text-left">
          <h5>KIERA GANANN</h5>
          <p>
          Chief Merchandising Officer
          </p>
        </div>
      </a>
      <div
        class="row mt-4 collapse close-button"
        id="collapseExample4"
        data-toggle="collapse"
        data-target="#collapseExample4"
        aria-expanded="false"
        aria-controls=""
        data-parent="#mbseniorleadershipcolapsegroup"
      >
        <div class="col-12">
          <p className="text-left">
          Kiera joined The Children’s Place in 2025 and has taken on roles with increasing responsibility. Currently serving as Chief Merchandising Officer, she leads the merchandising and design teams across all brands, with a strategic focus on advancing the company’s product vision and achieving excellence in design and merchandising across channels. Throughout her career, Kiera has effectively managed large teams across merchandising and commercial functions, consistently driving significant revenue growth, fortifying brand integrity, and delivering innovative product solutions aligned with evolving consumer trends. In her previous position, she served as Senior Vice President at Delta Galil, where she was Global General Manager for Ralph Lauren Intimates and Sleepwear. Prior to this, Kiera was the Vice President of Merchandising for North and South America at Levi’s, where she directed merchandising initiatives. Kiera has also held senior leadership roles at Ralph Lauren, overseeing sales and merchandising strategies for both the Men’s and Women’s divisions. She earned her Bachelor of Arts in Journalism/Advertising from the University of Oklahoma. 
          </p>
        </div>
      </div>
    </div>

    
<div>
      <a
        class="row btn p-0 mb-1 d-flex collapsed"
        data-toggle="collapse"
        href="#collapseExample1a"
        role="button"
        aria-expanded="false"
        aria-controls="collapseExample1a"
      >
        <div class="col-12">
          <hr class="border-top " />
        </div>
        <div class="col-4 fill">
          <img src={Alexandra} className="img-fluid mb-2" alt="" />
        </div>

        <div class="col-8 text-left">
          <h5>ALEXANDRA DERNER</h5>
          <p>Chief Growth Officer</p>
        </div>
      </a>
      <div
        class="row mt-4 collapse close-button"
        id="collapseExample1a"
        data-toggle="collapse"
        data-target="#collapseExample1a"
        aria-expanded="false"
        aria-controls=""
        data-parent="#mbseniorleadershipcolapsegroup"
      >
        <div class="col-12">
          <p className="text-left">
          Alexandra joined The Children’s Place in 2026 as the Chief Growth Officer. In this role, Alexandra leads our Strategic Partnerships, International, Marketplace, and Wholesale businesses. Her proven track record of driving growth through innovation, strategic partnerships, and operational excellence will be instrumental in advancing the Company’s long-term growth strategy. Throughout her career, Alexandra has successfully led business strategy, operations, and technology initiatives that enhance customer experience and accelerate growth. Prior to joining The Children’s Place, Alex spent 14 years at Amazon, where she led technology, product, and retail transformation initiatives. Alex earned her Bachelor of Science in Kinesiology from San Diego State University.
 
          </p>
        </div>
      </div>
    </div>

  <div>
      <a
        class="row btn p-0 mb-1 d-flex collapsed"
        data-toggle="collapse"
        href="#collapseExample3"
        role="button"
        aria-expanded="false"
        aria-controls="collapseExample3"
      >
        <div class="col-12">
          <hr class="border-top " />
        </div>
        <div class="col-4 fill">
          <img src={tileimage1452} className="img-fluid mb-2" alt="" />
        </div>

        <div class="col-8 text-left">
          <h5>KRISTIN CLIFFORD</h5>
          <p>
          Senior Vice President, Head of Global Sourcing & Product Operations
          </p>
        </div>
      </a>
      <div
        class="row mt-4 collapse close-button"
        id="collapseExample3"
        data-toggle="collapse"
        data-target="#collapseExample3"
        aria-expanded="false"
        aria-controls=""
        data-parent="#mbseniorleadershipcolapsegroup"
      >
        <div class="col-12">
          <p className="text-left">
          Kristin rejoined The Children’s Place in 2025 as the Senior Vice President, Head of Global Sourcing & Product Operations. Kristin leads sourcing and product initiatives and manages teams to develop costing strategies that meet the company’s financial targets by collaborating with external partners to produce high-quality, brand-consistent merchandise at competitive prices. Previously, Kristin worked at The Children’s Place from 2013 to 2020, where she held various roles of increasing responsibility, ultimately rising to the position of Vice President of Global Sourcing. Most recently, she served as the Senior Vice President of Sourcing at Vineyard Vines. Additionally, Kristin has held key leadership positions, including Senior Vice President of Global Sourcing at Juicy Couture and Vice President of Corporate Sourcing Operations at Liz Claiborne. She earned her Bachelor of Arts in Business Economics from Belmont Abbey College. 
          </p>
        </div>
      </div>
    </div>
  

        {/* <div>
      <a
        class="row btn p-0 mb-1 d-flex collapsed"
        data-toggle="collapse"
        href="#collapseExample5"
        role="button"
        aria-expanded="false"
        aria-controls="collapseExample5"
      >
        <div class="col-12">
          <hr class="border-top " />
        </div>
        <div class="col-4 fill">
          <img src={tileimage14534} className="img-fluid mb-2" alt="" />
        </div>

        <div class="col-8 text-left">
          <h5>RAJENDRA KARAMCHETI</h5>
          <p>
          Senior Vice President, Chief Technology Officer
          </p>
        </div>
      </a>
      <div
        class="row mt-4 collapse close-button"
        id="collapseExample5"
        data-toggle="collapse"
        data-target="#collapseExample5"
        aria-expanded="false"
        aria-controls=""
        data-parent="#mbseniorleadershipcolapsegroup"
      >
        <div class="col-12">
          <p className="text-left">
          Rajendra joined The Children’s Place in 2019 and has taken on roles with increasing responsibility throughout his tenure with TCP. Currently serving as SVP, Chief Technology Officer, Rajendra leads the company’s global technology strategy, overseeing IT, digital infrastructure, and innovative initiatives. He is responsible for driving technology transformation efforts that enhance operational efficiency, promote business growth, and improve the customer experience. Rajendra has played a key role in modernizing the company’s technology platforms, optimizing operations, and aligning digital capabilities with strategic business objectives. He holds a Bachelor’s degree in Computer and Information Science from Andhra University.
          </p>
        </div>
      </div>
    </div> */}

    <div>
      <a
        class="row btn p-0 mb-1 d-flex collapsed"
        data-toggle="collapse"
        href="#collapseExample7"
        role="button"
        aria-expanded="false"
        aria-controls="collapseExample7"
      >
        <div class="col-12">
          <hr class="border-top " />
        </div>
        <div class="col-4 fill">
          <img src={tileimage1451} className="img-fluid mb-2" alt="" />
        </div>

        <div class="col-8 text-left">
          <h5>PHILIP ENDE</h5>
          <p>Group Vice President, Head of Real Estate</p>
        </div>
      </a>
      <div
        class="row mt-4 collapse close-button"
        id="collapseExample7"
        data-toggle="collapse"
        data-target="#collapseExample7"
        aria-expanded="false"
        aria-controls=""
        data-parent="#mbseniorleadershipcolapsegroup"
      >
        <div class="col-12">
          <p className="text-left">
          Philip joined The Children’s Place in 2024 as Group Vice President, Head of Real Estate.  He oversees all real estate strategy and asset management, including acquisition, development, and leasing. Prior to joining, Philip served as President and Founder of Ende Real Estate Advisors, a real estate consulting firm.  Prior to that, he worked at Simon Property Group holding roles of increasing responsibility, culminating in his position as Senior Vice President – Leasing Premium Outlets.  Philip earned his Bachelor’s Degree from the University of Florida. 
          </p>
        </div>
      </div>
    </div>

    <div>
      <a
        class="row btn p-0 mb-1 d-flex collapsed"
        data-toggle="collapse"
        href="#collapseExample7a"
        role="button"
        aria-expanded="false"
        aria-controls="collapseExample7a"
      >
        <div class="col-12">
          <hr class="border-top " />
        </div>
        <div class="col-4 fill">
          <img src={kimKetch} className="img-fluid mb-2" alt="" />
        </div>

        <div class="col-8 text-left">
          <h5>KIM KETCH</h5>
          <p>Group Vice President, Head of Design</p>
        </div>
      </a>
      <div
        class="row mt-4 collapse close-button"
        id="collapseExample7a"
        data-toggle="collapse"
        data-target="#collapseExample7a"
        aria-expanded="false"
        aria-controls=""
        data-parent="#mbseniorleadershipcolapsegroup"
      >
        <div class="col-12">
          <p className="text-left">
          Kim joined The Children’s Place in 2015 and has taken on roles of increasing responsibility throughout her tenure, demonstrating strong leadership and a deep understanding of the brand. As GVP, Head of Design, she leads the end-to-end Design function, overseeing the full creative process from concept development and trend direction through final product execution. She partners closely with Merchandising, Production, and Marketing to bring cohesive, customer-focused assortments to market that support both brand vision and business objectives. In her role, Kim ensures every collection is innovative, commercially viable, and aligned with the company’s strategic priorities, while maintaining a consistent brand aesthetic across categories.  Kim holds a bachelor’s degree in Fashion Design from the Fashion Institute of Technology.
          </p>
        </div>
      </div>
    </div>
    


    <div>
      <a
        class="row btn p-0 mb-1 d-flex collapsed"
        data-toggle="collapse"
        href="#collapseExample9"
        role="button"
        aria-expanded="false"
        aria-controls="collapseExample9"
      >
        <div class="col-12">
          <hr class="border-top " />
        </div>
        <div class="col-4 fill">
          <img src={kenli} className="img-fluid mb-2" alt="" />
        </div>

        <div class="col-8 text-left">
          <h5>KENNETH LI</h5>
          <p>
          Group Vice President, General Counsel and Corporate Secretary
          </p>
        </div>
      </a>
      <div
        class="row mt-4 collapse close-button"
        id="collapseExample9"
        data-toggle="collapse"
        data-target="#collapseExample9"
        aria-expanded="false"
        aria-controls=""
        data-parent="#mbseniorleadershipcolapsegroup"
      >
        <div class="col-12">
          <p className="text-left">
Kenneth joined The Children’s Place in 2021 and has held roles of increasing responsibility throughout his tenure. As GVP, General Counsel and Corporate Secretary, he oversees TCP’s enterprise legal strategy and corporate administration matters, including the areas of board governance, litigation, intellectual property, real estate, employment, product safety, and enterprise risk. Partnering closely with leaders across the organization, Kenneth plays a key role in ensuring the company operates within sound legal frameworks, upholds effective corporate governance standards, and manages risk to support TCP’s strategic priorities and continued growth. Kenneth earned a Bachelor of Arts in Criminology, Ethics, Society & Law, and Linguistics, as well as his Juris Doctorate, from the University of Toronto.
 
          </p>
        </div>
      </div>
    </div>

    <div>
      <a
        class="row btn p-0 mb-1 d-flex collapsed"
        data-toggle="collapse"
        href="#collapseExample10"
        role="button"
        aria-expanded="false"
        aria-controls="collapseExample10"
      >
        <div class="col-12">
          <hr class="border-top " />
        </div>
        <div class="col-4 fill">
          <img src={ericwarner} className="img-fluid mb-2" alt="" />
        </div>

        <div class="col-8 text-left">
          <h5>ERIC WARNER</h5>
          <p>
          Group Vice President, Head of Human Resources
          </p>
        </div>
      </a>
      <div
        class="row mt-4 collapse close-button"
        id="collapseExample10"
        data-toggle="collapse"
        data-target="#collapseExample10"
        aria-expanded="false"
        aria-controls=""
        data-parent="#mbseniorleadershipcolapsegroup"
      >
        <div class="col-12">
          <p className="text-left">
          Eric joined The Children's Place in 2022 and has held roles of increasing responsibility throughout his tenure with the organization. As GVP, Head of Human Resources, he leads TCP’s enterprise people strategy, overseeing talent acquisition, total rewards, HR operations, talent management, associate experience, and organizational effectiveness. Partnering closely with leaders across the organization, Eric plays a key role in strengthening the company’s culture, developing high-performing teams, and building the capabilities needed to support TCP’s strategic priorities and continued growth. He holds a Master’s degree in Information Systems and Business Administration from Temple University.
          </p>
        </div>
      </div>
    </div>



     <div>
      
      <a
        class="row btn p-0 mb-1 d-flex collapsed"
        data-toggle="collapse"
        href="#collapseExample11"
        role="button"
        aria-expanded="false"
        aria-controls="collapseExample11"
      >
        <div class="col-12">
          <hr class="border-top " />
        </div>
        <div class="col-4 fill">
          <img src={tileimage145345} className="img-fluid mb-2" alt="" />
        </div>

        <div class="col-8 text-left">
          <h5>TIFFANY WHITFORD</h5>
          <p>
          Group Vice President, Head of Stores
          </p>
        </div>
      </a>
      <div
        class="row mt-4 collapse close-button"
        id="collapseExample11"
        data-toggle="collapse"
        data-target="#collapseExample11"
        aria-expanded="false"
        aria-controls=""
        data-parent="#mbseniorleadershipcolapsegroup"
      >
        <div class="col-12">
          <p className="text-left">
          Tiffany joined The Children’s Place in 2025 as the Group Vice President, Head of Stores, bringing with her a passion for creating exceptional customer experiences. In her role, she oversees store operations and field leadership, prioritizing impactful connections with customers. Prior to this, Tiffany served as Zone Vice President for Sunglass Hut Northeast at EssilorLuxottica and held influential positions at MAC Cosmetics North America and Kate Spade & Company. Tiffany's collaborative and results-driven leadership style is known for strengthening customer relationships and driving impressive growth. She holds a BFA and an AAS in Fashion Buying and Merchandising from the Fashion Institute of Technology.
          </p>
        </div>
      </div>
    </div>


  </div>
)

export default MBSeniorLeadership
